import { useState } from "react";
import { Button } from "@/components/ui/button";

const QUICK_RESPONSES = [
  { emoji: "👍", text: "Yes" },
  { emoji: "👎", text: "No" },
  { emoji: "😊", text: "Happy" },
  { emoji: "😢", text: "Sad" },
  { emoji: "💖", text: "Love" },
  { emoji: "🎉", text: "Great!" },
  { emoji: "🙏", text: "Please" },
  { emoji: "✋", text: "Stop" },
  { emoji: "🍎", text: "Food" },
  { emoji: "💧", text: "Water" },
  { emoji: "🛏️", text: "Sleep" },
  { emoji: "🚽", text: "Bathroom" },
];

interface QuickResponsesProps {
  disabled?: boolean;
  onSelect: (content: string) => void;
}

export default function QuickResponses({ disabled = false, onSelect }: QuickResponsesProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="space-y-2">
      <Button
        type="button"
        variant={isOpen ? "default" : "outline"}
        disabled={disabled}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        Quick Responses
      </Button>
      {isOpen && (
        <div className="grid grid-cols-3 gap-2 rounded-lg border border-gray-200 bg-white p-3 sm:grid-cols-6">
          {QUICK_RESPONSES.map(({ emoji, text }) => (
            <Button
              key={text}
              type="button"
              variant="outline"
              className="flex h-auto flex-col gap-1 py-2"
              disabled={disabled}
              onClick={() => onSelect(`${emoji} ${text}`)}
            >
              <span className="text-xl">{emoji}</span>
              <span className="text-xs">{text}</span>
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}